module.exports = __webpack_public_path__ + "img/title.5d361ca1.jpg";